import React, { useEffect, useRef } from 'react';

// ── Trigger detection ────────────────────────────────────────
// A canned-response trigger is recognised only when the ENTIRE reply
// box currently contains a slash command being typed, e.g. "/pric".
// As soon as a space is typed (or the leading "/" is removed) it's no
// longer treated as a shortcut in progress and the dropdown closes.
// This mirrors Slack/Chatwoot's "/" behaviour rather than trying to
// match a slash anywhere mid-sentence, which would trigger constantly
// on ordinary text containing "/".
export function matchCannedTrigger(text) {
  if (!text.startsWith('/')) return null;
  const query = text.slice(1);
  if (/\s/.test(query)) return null; // space typed — no longer a trigger
  return query.toLowerCase();
}

export function filterCannedResponses(list, query) {
  if (!query) return list;
  return list.filter(c => c.crShortcut.toLowerCase().startsWith(query));
}

// ── Dropdown ──────────────────────────────────────────────────
// Rendered directly above the reply textarea (not caret-following —
// there's normally only ever one line of text when a shortcut is
// being typed, so anchoring to the input itself is simplest and most
// reliable across mobile/desktop).
export default function CannedResponseDropdown({ items, activeIndex, onPick, onHoverIndex }) {
  const listRef = useRef(null);

  // Keep the highlighted row scrolled into view as arrow keys move it
  useEffect(() => {
    const el = listRef.current?.children?.[activeIndex];
    if (el) el.scrollIntoView({ block: 'nearest' });
  }, [activeIndex]);

  if (items.length === 0) {
    return (
      <div className="canned-dropdown">
        <div className="canned-dropdown-empty">No matching shortcuts</div>
      </div>
    );
  }

  return (
    <div className="canned-dropdown">
      <ul className="canned-dropdown-list" ref={listRef}>
        {items.map((c, i) => (
          <li
            key={c.crId}
            className={`canned-dropdown-item ${i === activeIndex ? 'active' : ''}`}
            onMouseDown={e => { e.preventDefault(); onPick(c); }}
            onMouseEnter={() => onHoverIndex(i)}
          >
            <span className="canned-dropdown-shortcut">/{c.crShortcut}</span>
            <span className="canned-dropdown-preview">{c.crBody}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}